import React from "react";
import { motion } from "framer-motion";
import "./Team.css";
import Azhagapan from '../../assets/Azhagapan.jpeg'
import Swathi from '../../assets/Swathi.jpeg'
import Hari from '../../assets/Hari.jpeg'
import Dhanush from '../../assets/Dhanush.jpeg'
import Camillus from '../../assets/Camillus.jpeg'

const Team = () => {
  return (
    <div>
      <div className="team_cards">
       
        <div className="team_card_bg">
          <img 
            src={Swathi}
            alt="Image not found" 
            className="team_img"
          />
         
          <div className="team_cards_text">
            <h1>Swathi R</h1>
            <p>Full Stack Developer</p>
            <button
              onClick={() => window.open("https://rswathi41103.github.io/Portfolio/", "_blank")}
              className="team_cards_text_a"
            >
              Portfolio
            </button>

          </div>
        </div>
        <div className="team_card_bg">
          <img 
            src={Hari}
            alt="Image not found" 
            className="team_img"
          />
          <div className="team_cards_text">
            <h1>Hari Krishnan</h1>
            <p>Full Stack Developer</p>
            <button
              onClick={() => window.open("https://hariiikrishnan.github.io/", "_blank")}
              className="team_cards_text_a"
            >
              Portfolio
            </button>

          </div>
        </div>
        <div className="team_card_bg">
          <img 
            src={Camillus}
            alt="Image not found" 
            className="team_img"
          />
          <div className="team_cards_text">
            <h1>Camillus</h1>
            <p>Graphic Designer</p>
            <button onClick={() => window.open("http://camillus.co.uk/?fbclid=PAZXh0bgNhZW0CMTEAAadXcsZ2ibnNMWPZAIecFuDUJ2QNzrxWxIt9sSSTf9JueMfYp0jVRBix-kO1KA_aem_bk6YeOe_7fxJr5ZQwTNm2Q", "_blank")} className="team_cards_text_a">Portfolio</button>
          </div>
        </div>
        <div className="team_card_bg">
          <img 
            src={Azhagapan} 
            alt="Image not found" 
            className="team_img"
          />
          <div className="team_cards_text">
            <h1>Azhagapan K</h1>
            <p>Data Analyst</p>
            <button
              onClick={() => window.open("https://dhanushnofficial.github.io/dhanush/", "_blank")}
              className="team_cards_text_a"
            >
              Portfolio
            </button>

          </div>
        </div>
        
        <div className="team_card_bg">
          <img 
            src={Dhanush}
            alt="Image not found" 
            className="team_img"
          />
          <div className="team_cards_text">
            <h1>Dhanush N</h1>
            <p>Full Stack Developer</p>
            <button
              onClick={() => window.open("https://dhanushnofficial.github.io/dhanush/", "_blank")}
              className="team_cards_text_a"
            >
              Portfolio
            </button>

          </div>
        </div>
      </div>

    </div>
  );
};

export default Team;
